var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-badge"},[_vm._t("default"),_vm._v(" "),_c('sup',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden && (_vm.content || _vm.isDot)),expression:"!hidden && (content || isDot)"}],staticClass:"nut-badge__content",class:{ 'is-dot': _vm.isDot },style:(_vm.stl),domProps:{"textContent":_vm._s(_vm.content)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }